"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingEQBar = void 0;
const React = __importStar(require("react"));
const EQBar_1 = require("./EQBar");
const PricingEQBar_styled_1 = require("./PricingEQBar.styled");
const PricingEQBar = (props) => {
    const { minPrice, standardPrice, maxPrice, currencySymbol, averageNightlyPrices, omitLegend } = props;
    return React.createElement(PricingEQBar_styled_1.StyleWrapper, { height: props.height || '200px', "data-testid": "pricing-eq-bar" },
        React.createElement("div", { className: "pricing-eq-bar-graph__flex-box-horizontal" },
            (omitLegend === undefined || (omitLegend !== undefined && omitLegend === false)) &&
                React.createElement("div", { className: "pricing-eq-bar-graph__legend" },
                    React.createElement("span", { className: "pricing-eq-bar-graph__min-price" }, minPrice > 0 && currencySymbol + minPrice),
                    React.createElement("span", { className: "pricing-eq-bar-graph__std-price" }, standardPrice > 0 && currencySymbol + standardPrice),
                    React.createElement("span", { className: "pricing-eq-bar-graph__max-price" }, maxPrice > 0 && currencySymbol + maxPrice)),
            React.createElement("div", { className: "pricing-eq-bar-graph__bars" }, averageNightlyPrices.map((nightlyPrice, idx) => {
                return React.createElement("div", { key: `${nightlyPrice.name}-${idx}`, className: "pricing-eq-bar-graph__bar" },
                    React.createElement(EQBar_1.EQBar, { name: nightlyPrice.name, percentage: nightlyPrice.percentage, height: '100%', width: '100%' }));
            }))));
};
exports.PricingEQBar = PricingEQBar;
//# sourceMappingURL=PricingEQBar.js.map